import * as React from 'react'
import {ComponentExt} from '@utils/reactExt'
import {observer, inject} from 'mobx-react'
import {deepClone} from '@src/utils';
import * as styles from './style/index.scss'
import {WhiteSpace, Button} from 'antd-mobile'
import {FormattedMessage} from 'react-intl'

@inject('userStore')
@observer
class PackageDetail extends ComponentExt<any, any> {
    private userStore: any

    constructor(props) {
        super(props)
        this.userStore = props.userStore
    }

    render() {
        const initInfo = deepClone(this.userStore.initPackage) || {}
        const _str = initInfo.productInfo
        const _infoList = !!_str ? _str.split('\n') : []
        return (
            <div className={styles.packageDetail}>
                <div className={styles.packageBaseInfo}>
                    <FormattedMessage id="home.active.detail.title"/>
                </div>
                <WhiteSpace className={styles.whiteSpace}/>
                {/*套餐说明*/}
                <div className={styles.packageIntro}>
                    {_infoList && _infoList.map((item, index) => {
                        return (<p key={index}>{`${item}`}</p>)
                    })}
                    <p style={{marginTop: '20px'}}>
                        <FormattedMessage
                            id="home.active.detail.faq"
                            values={{
                                a: chunks => <a style={{color: '#eb6a1a'}} onClick={() => {this.goToPath('/global/contactUs')}}>{chunks}</a>
                            }}
                        />
                    </p>
                </div>
                <Button className={styles.btn} onClick={() => this.goBack()}>
                    {'<'}&nbsp;<FormattedMessage id="pay.back"/>
                </Button>
            </div>
        )
    }
}

export default PackageDetail
